/** @jsxImportSource @emotion/react */
import { Modal as BaseModal, ModalProps } from "antd";
import { css } from "@emotion/react";
import { StyledText } from "../assets/typography/typography";

type Props = {
  isOpen: boolean;
  onClose?: () => void;
  children: any;
  width?: string | number;
  header?: string;
  subtitle?: string;
  closable?: boolean;
} & ModalProps;

const headerStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Modal = ({
  isOpen,
  onClose,
  children,
  width,
  header,
  subtitle,
  closable = true,
  ...rest
}: Props) => {
  const modalStyle = css`
    display: flex;
    flex-direction: column;
    ${closable &&
    `
    margin-top: 32px;
    `}
    gap: 16px;
  `;

  return (
    <BaseModal
      open={isOpen}
      onCancel={onClose}
      width={width}
      footer={null}
      centered
      closable={closable}
      {...rest}
    >
      <div css={modalStyle}>
        {header && (
          <div css={headerStyle}>
            <StyledText className="headerFour mb-0">{header}</StyledText>
            {subtitle && (
              <StyledText className="bodyTextRegular mb-0">
                {subtitle}
              </StyledText>
            )}
          </div>
        )}
        {children}
      </div>
    </BaseModal>
  );
};
